export const LOAD_OHCASES_SUCCESS = "LOAD_OHCASES_SUCCESS";
export const LOAD_DETAILED_OHCASES_SUCCESS = "LOAD_DETAILED_OHCASES_SUCCESS";

export const CREATE_OHCASE_SUCCESS = "CREATE_OHCASE_SUCCESS";

export const UPDATE_ASSOCIATED_MANAGERS_SUCCESS = "UPDATE_ASSOCIATED_MANAGERS_SUCCESS";
export const UPDATE_ASSOCIATED_HR_USERS_SUCCESS = "UPDATE_ASSOCIATED_HR_USERS_SUCCESS";
export const UPDATE_PURCHASE_ORDER_NUMBER_SUCCESS = "UPDATE_PURCHASE_ORDER_NUMBER_SUCCESS";

export const LOAD_OHCASE_DETAIL_SUCCESS = "LOAD_OHCASE_DETAIL_SUCCESS";

export const CREATE_TASK_SUCCESS = "CREATE_TASK_SUCCESS";

export const CREATE_TASKS_SUCCESS = "CREATE_TASKS_SUCCESS";

export const CANCEL_TASK_SUCCESS = "CANCEL_TASK_SUCCESS";

export const ACTION_TASK_SUCCESS = "ACTION_TASK_SUCCESS";

export const CREATE_OHCASE_DOCUMENT_SUCCESS = "CREATE_OHCASE_DOCUMENT_SUCCESS";

export const UPDATE_OHCASE_DOCUMENT_SUCCESS = "UPDATE_OHCASE_DOCUMENT_SUCCESS";

export const LOAD_OHCASE_DOCUMENTS_SUCCESS = "LOAD_OHCASE_DOCUMENTS_SUCCESS";

export const DELETE_OHCASE_DOCUMENT_SUCCESS = "DELETE_OHCASE_DOCUMENT_SUCCESS";

export const MARK_OH_CASE_IMMS_CLEAR = "MARK_OH_CASE_IMMS_CLEAR";

export const CREATE_OHCASE_TASK = "CREATE_OHCASE_TASK";
export const CREATE_OHCASE_TASKS = "CREATE_OHCASE_TASKS";
export const ADD_FILE_NOTE = "ADD_FILE_NOTE";
export const CANCEL_OHCASE_TASK = "CANCEL_OHCASE_TASK";
export const ACTION_TASK = "ACTION_TASK";

export const LOAD_OHCASE_DETAIL = "LOAD_OHCASE_DETAIL";
export const LOAD_OHCASE_DOCUMENTS = "LOAD_OHCASE_DOCUMENTS";
export const LOAD_OHCASE_SEARCH_DETAIL = "LOAD_OHCASE_DETAIL";

export const DELETE_OHCASE_DOCUMENT = "DELETE_OHCASE_DOCUMENT";

export const CREATE_IMMUNISATION_CASE = "CREATE_IMMUNISATION_CASE";
export const CREATE_IMMUNISATION_CASE_SUCCESS = "CREATE_IMMUNISATION_CASE_SUCCESS";

export const CREATE_BBV_CASE = "CREATE_BBV_CASE";
export const CREATE_BBV_CASE_SUCCESS = "CREATE_BBV_CASE_SUCCESS";

export const CREATE_HEALTH_SURVEILLANCE_CASE_SUCCESS = "CREATE_HEALTH_SURVEILLANCE_CASE_SUCCESS";

export const LOAD_OH_CASES = "LOAD_OH_CASES";

export const LOAD_OHCASE_DETAILS = "LOAD_OHCASE_DETAILS";

export const CREATE_OHCASE = "CREATE_OHCASE";

export const CREATE_PHYSIOTHERAPY_CASE = "CREATE_PHYSIOTHERAPY_CASE";

export const EDIT_TASK_COMPLETION_DATA = "EDIT_TASK_COMPLETION_DATA";
export const EDIT_TASK_COMPLETION_DATA_SUCCESS = "EDIT_TASK_COMPLETION_DATA_SUCCESS";

export const DELETE_TASK = "DELETE_TASK";
export const DELETE_TASK_SUCCESS = "DELETE_TASK_SUCCESS";

export const SET_OHCASE_CONFIDENTIALITY = "SET_OHCASE_CONFIDENTIALITY";
export const SET_OHCASE_CONFIDENTIALITY_SUCCESS = "SET_OHCASE_CONFIDENTIALITY_SUCCESS";

export const SEARCH_FOR_EMPLOYEE = "SEARCH_FOR_EMPLOYEE";
export const UPDATE_OHCASE_DETAILS = "UPDATE_OHCASE_DETAILS";
